import Flex from '@totallymoney/ui/components/Flex'
import Row from '@totallymoney/ui/components/Row'
import Text from '@totallymoney/ui/components/Text'
import Icon from '@totallymoney/ui/icons/Icon'
import theme from '@totallymoney/ui/theme'

interface SpecialOfferBadgeProps {
    description: string
    title: string
}

const SpecialOfferBadge = ({ description, title }: SpecialOfferBadgeProps) => {
    if (!description && !title) {
        return null
    }

    return (
        <Row
            space="space10"
            backgroundColor="grey20"
            p="space10"
            borderRadius="borderRadius10"
            alignItems="center"
            width={['100%', 'fit-content']}
        >
            <Flex alignSelf="flex-start">
                <Icon icon="lightBulbTip" size={16} color={theme.grey100} />
            </Flex>

            <Text variant="60" color="light">
                <strong>{title}</strong>{' '}
                {description ? ` - ${description}` : ''}
            </Text>
        </Row>
    )
}

export default SpecialOfferBadge
